























































import { Vue, Component, Prop } from "vue-property-decorator";
import { Debounce } from "vue-debounce-decorator";

import QuickFilters from "@common/table/components/filter/QuickFilters.vue";
import FilterModal from "@common/table/components/filter/FilterModal.vue";
import ControlWrapper from "@share/common/ControlWrapper.vue";
import ToggleButton from "@common/vue-toggle-btn/toggle-btn.vue"
import TableSearch from "@share/common/table-search/TableSearch.vue";

import { FilterSetting } from "@common/table/interfaces/FilterSetting";
import { FilterType } from "@common/table/enums/FilterTypes";
import { TicketsListFilterState } from "@share/common/services/ticket/list/TicketsListFilterState";
import { getDefaultToggleOptions } from "@common/vue-toggle-btn/helpers/optionsFabric";
import MiniClose from "../../../../../../assets/svg/mini-close.svg"

@Component({ components: { TableSearch, QuickFilters, FilterModal, ControlWrapper, ToggleButton, MiniClose } })

export default class TicketsSelectFilters extends Vue {

    @Prop() filters: FilterSetting<TicketsListFilterState>[];
    @Prop({ required: true }) filterState: TicketsListFilterState;
    @Prop({ default: 0 }) selectedCount: number;
    @Prop({ default: false }) selectedFiltered: boolean;

    isFiltersModalVisible = false;
    toggleOptions = getDefaultToggleOptions();

    applyFilters() {
        this.isFiltersModalVisible = false;

        this.filters.forEach((filter) => {

            if(
                filter.name === "isOnlyAssignedForMe" ||
                filter.name === "type" ||
                filter.name === "orderDirection"
            ) {
                return;
            }

            if(filter.type === FilterType.text) {
                this.filterState[filter.name] = filter.value || "";
            }

            if(filter.type === FilterType.dateRange && this.filterState.createdAt) {
                this.filterState.createdAt.start = filter.selectedItem?.start || "";
                this.filterState.createdAt.end = filter.selectedItem?.end || "";
            }

            if(filter.type === FilterType.select) {
                this.filterState[filter.name] = filter.selectedItem?.id;
            }
        });

        this.$emit('filter');
    }

    @Debounce(250)
    toggleIsOnlyAssignedForMe(value: boolean) {
        this.filterState.isOnlyAssignedForMe = value;
        this.$emit('filter');
    }

    @Debounce(250)
    onSearchInput() {
        if((this.filterState.keyword?.length || 0) > 2 || !this.filterState.keyword?.length) {
            this.$emit('filter');
        }
    }

    resetFilters() {
        this.isFiltersModalVisible = false;
        this.$emit('reset');
    }

    clearInput() {
        this.filterState.keyword = "";
        this.$emit('filter');
    }

    showFiltersModal() {
        this.isFiltersModalVisible = true;
    }

    /**
     * TODO: it need to move this getter to FilterState class
     *
     * and call it like this: this.filterState.isFilterSet: boolean
     */
    get isFilterSet() {
        let result = false;

        const filterState = this.filterState as Record<string, any>;

        for (const key in filterState) {

            if(result) {
                break;
            }

            if(key === "isOnlyAssignedForMe" || key === "type" || key === "keyword" || key === "orderDirection" || key === "sortedField") {
                continue
            }

            if (Object.prototype.hasOwnProperty.call(filterState, key)) {

                if(key === "createdAt") {
                    result = !!filterState[key].start || !!filterState[key].start
                }
                else {
                    result = !!filterState[key];
                }
            }
        }

        return result;
    }
}

